import { useState } from "react";
import { FaShareAlt, FaCheck } from "react-icons/fa";

const ShareLink = ({ url, title = "Dela denna sida", text = "Dela" }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    // Om ingen url anges, använd den aktuella sidans url
    const shareUrl = url || window.location.href;

    // Försök använda den inbyggda dela-funktionen på mobiler först
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: shareUrl,
        });
        return; // Avsluta om delning lyckades
      } catch (err) {
        // Om användaren avbryter dialogen (AbortError) gör vi ingenting, 
        // annars kan vi falla tillbaka till kopiering
        if (err.name !== "AbortError") {
          console.error("Fel vid delning", err);
        } else {
          return;
        }
      }
    }

    // Fallback: Kopiera till urklipp om navigator.share inte finns (t.ex. på desktop)
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (err) {
      console.error("Kunde inte kopiera länk", err);
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`btn btn-sm ${copied ? "btn-success text-white" : "btn-outline"} gap-2`}
      title="Dela länk"
    >
      {copied ? <FaCheck /> : <FaShareAlt />}
      <span className="hidden sm:inline">{copied ? "Kopierad!" : text}</span>
    </button>
  );
};

export default ShareLink;
